module.exports = __webpack_public_path__ + "media/images/dragDrop__infoIcon@3x-002a13a88cf3323cc025861fdcb35a7c.png";